import restaurantHeroImg from "../assets/samples/restaurant/hero.jpg";
import restaurantServicesImg from "../assets/samples/restaurant/services.jpg";
import restaurantReservationsImg from "../assets/samples/restaurant/reservations.jpg";
import restaurantAboutImg from "../assets/samples/restaurant/about-us.jpg";
import restaurantContactImg from "../assets/samples/restaurant/contact.jpg";
import restaurantProduct1Img from "../assets/samples/restaurant/product1.jpg";
import restaurantProduct2Img from "../assets/samples/restaurant/product2.jpg";
import restaurantProduct3Img from "../assets/samples/restaurant/product3.jpg";

import barberHeroImg from "../assets/samples/barber/hero.jpg";
import barberServicesImg from "../assets/samples/barber/services.jpg";
import barberReservationsImg from "../assets/samples/barber/reservations.jpg";
import barberAboutImg from "../assets/samples/barber/about-us.jpg";
import barberContactImg from "../assets/samples/barber/contact.jpg";
import barberProduct1Img from "../assets/samples/barber/product1.jpg";
import barberProduct2Img from "../assets/samples/barber/product2.jpg";
import barberProduct3Img from "../assets/samples/barber/product3.jpg";

import salonHeroImg from "../assets/samples/salon/hero.jpg";
import salonServicesImg from "../assets/samples/salon/services.jpg";
import salonReservationsImg from "../assets/samples/salon/reservations.jpg";
import salonAboutImg from "../assets/samples/salon/about-us.jpg";
import salonContactImg from "../assets/samples/salon/contact.jpg";
import salonProduct1Img from "../assets/samples/salon/product1.jpg";
import salonProduct2Img from "../assets/samples/salon/product2.jpg";
import salonProduct3Img from "../assets/samples/salon/product3.jpg";

import hairdresserHeroImg from "../assets/samples/salon/hero.jpg";
import hairdresserServicesImg from "../assets/samples/salon/services.jpg";
import hairdresserReservationsImg from "../assets/samples/salon/reservations.jpg";
import hairdresserAboutImg from "../assets/samples/salon/about-us.jpg";
import hairdresserContactImg from "../assets/samples/salon/contact.jpg";
import hairdresserProduct1Img from "../assets/samples/salon/product1.jpg";
import hairdresserProduct2Img from "../assets/samples/salon/product2.jpg";
import hairdresserProduct3Img from "../assets/samples/salon/product3.jpg";

// Para shop/tienda, usamos imágenes genéricas (por ahora reutilizamos salon como placeholder)
// TODO: Añadir imágenes específicas de tienda cuando estén disponibles
import shopHeroImg from "../assets/samples/shop/hero.jpg";
import shopServicesImg from "../assets/samples/shop/services.jpg";
import shopReservationsImg from "../assets/samples/shop/reservations.jpg";
import shopAboutImg from "../assets/samples/shop/about-us.jpg";
import shopContactImg from "../assets/samples/shop/contact.jpg";
import shopProduct1Img from "../assets/samples/shop/product1.jpg";
import shopProduct2Img from "../assets/samples/shop/product2.jpg";
import shopProduct3Img from "../assets/samples/shop/product3.jpg";

const DEFAULT_IMAGES = {
	restaurant: {
		hero: restaurantAboutImg,
		preview: restaurantHeroImg,
		about: restaurantAboutImg,
		services: restaurantServicesImg,
		reservations: restaurantReservationsImg,
		contact: restaurantContactImg,
		product1: restaurantProduct1Img,
		product2: restaurantProduct2Img,
		product3: restaurantProduct3Img,
	},
	barber: {
		hero: barberAboutImg,
		preview: barberHeroImg,
		about: barberAboutImg,
		services: barberServicesImg,
		reservations: barberReservationsImg,
		contact: barberContactImg,
		product1: barberProduct1Img,
		product2: barberProduct2Img,
		product3: barberProduct3Img,
	},
	salon: {
		preview: salonHeroImg,
		hero: salonAboutImg,
		about: salonAboutImg,
		services: salonServicesImg,
		reservations: salonReservationsImg,
		contact: salonContactImg,
		product1: salonProduct1Img,
		product2: salonProduct2Img,
		product3: salonProduct3Img,
	},
	hairdresser: {
		preview: hairdresserHeroImg,
		hero: hairdresserAboutImg,
		about: hairdresserAboutImg,
		services: hairdresserServicesImg,
		reservations: hairdresserReservationsImg,
		contact: hairdresserContactImg,
		product1: hairdresserProduct1Img,
		product2: hairdresserProduct2Img,
		product3: hairdresserProduct3Img,
	},
	shop: {
		preview: shopHeroImg,
		hero: shopAboutImg,
		about: shopAboutImg,
		services: shopServicesImg,
		reservations: shopReservationsImg,
		contact: shopContactImg,
		product1: shopProduct1Img,
		product2: shopProduct2Img,
		product3: shopProduct3Img,
	},
};

const buildML = (es, en, ca) => ({
	es,
	en,
	ca,
});

const buildPlaceholderLogo = (mainColor) => {
	const safeColor = mainColor || "#111827";
	const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='300' height='100' viewBox='0 0 300 100'>
		<text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle'
			font-family='Inter, sans-serif' font-size='36' font-weight='600'
			fill='${safeColor}' letter-spacing='6'>
			TU LOGO
		</text>
	</svg>`;

	return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
};

const buildHeroTitleML = (businessName, fallbackEs, fallbackEn, fallbackCa) => {
	const hasCustomName =
		businessName && businessName.trim() && businessName !== "Tu negocio";

	if (hasCustomName) {
		return buildML(businessName, businessName, businessName);
	}

	return buildML(fallbackEs, fallbackEn, fallbackCa);
};

const buildRestaurantFeatured = (images) => [
	{
		id: "default-feature-1",
		media: [{ url: images.product1 }],
		price: 18.0,
		title_ml: buildML(
			"Pulpo a la Brasa con Patatas",
			"Octopus on the grill with potatoes",
			"Pop a la brasa amb patates"
		),
		description_ml: buildML(
			"Pulpo tierno marcado a la brasa, acompañado de patatas baby trufadas y un toque de pimentón ahumado.",
			"Tender octopus marked on the grill, accompanied by baby truffle potatoes and a touch of smoked paprika.",
			"Pop tendre marcat a la brasa, acompanyat de patates baby amb tòfona i un toc de pebre vermell fumat."
		),
	},
	{
		id: "default-feature-2",
		media: [{ url: images.product2 }],
		price: 14.5,
		title_ml: buildML(
			"Lomo de Lubina al Horno con Verduras",
			"Salmon fillet baked with vegetables",
			"Llom de llobarro al forn amb verdures"
		),
		description_ml: buildML(
			"Lubina fresca horneada lentamente, servida con calabacín, berenjena y pimientos asados, todo aromatizado con hierbas mediterráneas.",
			"Fresh salmon baked slowly, served with zucchini, eggplant and roasted peppers, all seasoned with Mediterranean herbs.",
			"Llobarro fresc forn al forn lentament, servit amb carbassó, albergínia i pebrots rostits, tot aromatitzat amb herbes mediterrànies."
		),
	},
	{
		id: "default-feature-3",
		media: [{ url: images.product3 }],
		price: 9,
		title_ml: buildML(
			"Tartar de Atún con Aguacate",
			"Tuna Tartare with Avocado",
			"Tàrtar de tonyina amb alvocat"
		),

		description_ml: buildML(
			"Dados de atún rojo marinados con soja suave y sésamo, servidos sobre una base de aguacate cremoso.",
			"Diced bluefin tuna marinated with light soy and sesame, served on a creamy avocado base.",
			"Daus de tonyina vermella marinats amb soja suau i sèsam, servits sobre una base d'alvocat cremós."
		),
	},
];

const buildGallery = (images) => [
	{ id: "gallery-default-1", image: images.services },
	{ id: "gallery-default-2", image: images.reservations },
	{ id: "gallery-default-3", image: images.about },
];

const buildSchedule = (type = "restaurant") => {
	if (type === "barber" || type === "salon" || type === "hairdresser") {
		return [
			"Lunes a Viernes · 10:00 - 20:00",
			"Sábados · 10:00 - 14:00",
			"Domingos · Cerrado",
		].join(" · ");
	}
	return [
		"De lunes a viernes · 10:00 - 22:00",
		"Sábados · 10:00 - 00:00",
		"Domingos · 10:00 - 18:00",
	].join(" · ");
};

const isPlainObject = (value) =>
	value !== null && typeof value === "object" && !Array.isArray(value);

const parseMlField = (value) => {
	if (value == null) return value;
	if (typeof value === "string") {
		try {
			return JSON.parse(value);
		} catch {
			return value;
		}
	}
	return value;
};

const hasMlContent = (template, fieldName) => {
	if (!template) return false;
	const ml = parseMlField(template[`${fieldName}_ml`]);
	if (ml && typeof ml === "object" && !Array.isArray(ml)) {
		return Object.values(ml).some(
			(v) => v != null && String(v).trim().length > 0,
		);
	}
	const flat = template[fieldName];
	return flat != null && String(flat).trim().length > 0;
};

const normalizeTemplateMlFields = (template) => {
	if (!template || typeof template !== "object") return template || {};
	const out = { ...template };
	const mlSuffix = "_ml";
	Object.keys(out).forEach((key) => {
		if (key.endsWith(mlSuffix) && typeof out[key] === "string") {
			out[key] = parseMlField(out[key]);
		}
	});
	return out;
};

const mergeDefaults = (actual = {}, defaults = {}) => {
	const merged = { ...defaults };

	// Preserve keys only in actual
	Object.keys(actual).forEach((key) => {
		const actualValue = actual[key];
		const defaultValue = defaults[key];

		if (Array.isArray(actualValue)) {
			merged[key] =
				actualValue.length > 0
					? actualValue
					: Array.isArray(defaultValue)
					? defaultValue
					: [];
		} else if (isPlainObject(actualValue) && isPlainObject(defaultValue)) {
			merged[key] = mergeDefaults(actualValue, defaultValue);
		} else if (
			actualValue !== undefined &&
			actualValue !== null &&
			actualValue !== ""
		) {
			merged[key] = actualValue;
		} else if (defaultValue !== undefined) {
			merged[key] = defaultValue;
		} else {
			merged[key] = actualValue;
		}
	});

	// Ensure default-only keys are present
	Object.keys(defaults).forEach((key) => {
		if (!(key in merged)) {
			merged[key] = defaults[key];
		}
	});

	return merged;
};

const normalize = (value) =>
	typeof value === "string" ? value.toLowerCase() : "";

const getBusinessCategory = (creator) => {
	const appType = normalize(creator?.app?.appType);
	const appSubtype = normalize(creator?.app?.appSubtype);
	const tags = `${appType} ${appSubtype}`;

	// PRIORIDAD: Primero verificar si es ecommerce/woocommerce Y NO es restaurante
	const isEcommerceNotRestaurant = 
		(appType === "ecommerce" || appType === "woocommerce") &&
		appSubtype !== "restaurant";
	
	if (isEcommerceNotRestaurant) {
		return "shop";
	}

	if (
		tags.includes("barber") ||
		tags.includes("barbería") ||
		tags.includes("barberia")
	) {
		return "barber";
	}
	if (
		tags.includes("hair") ||
		tags.includes("peluquer") ||
		tags.includes("hairdress")
	) {
		return "hairdresser";
	}
	if (
		tags.includes("salon") ||
		tags.includes("salón") ||
		tags.includes("spa") ||
		tags.includes("belleza") ||
		tags.includes("estetica") ||
		tags.includes("estética")
	) {
		return "salon";
	}
	if (tags.includes("restaurant") || tags.includes("food")) {
		return "restaurant";
	}
	return appType === "services" || appType === "events" ? "salon" : "generic";
};

const presetBuilders = {
	restaurant: ({ businessName, city }) => ({
		backgroundColor: "#f9f6f0",
		mainColor: "#d97706",
		fontFamily: "Playfair Display, serif",
		images: DEFAULT_IMAGES.restaurant,
		copy: {
			title: buildML(
				`${businessName}: cocina honesta y cercana`,
				`${businessName}: honest, locally-inspired food`,
				`${businessName}: cuina honesta i propera`
			),
			description: buildML(
				`Descubre ${businessName}, un espacio gastronómico en ${city} donde trabajamos con productos locales y recetas de inspiración mediterránea.`,
				`Discover ${businessName}, a gastronomic space in ${city} where we celebrate local produce with a Mediterranean soul.`,
				`Descobreix ${businessName}, un espai gastronòmic a ${city} on celebrem el producte local amb ànima mediterrània.`
			),
			heroTitle: buildHeroTitleML(
				businessName,
				"Sabores artesanales cada día",
				"Artisanal flavours every day",
				"Sabor artesanal cada dia"
			),
			heroSubtitle: buildML(
				"Menú de mercado, pan recién horneado y una selección de vinos naturales que cambia con las estaciones.",
				"Market-fresh menus, freshly baked bread and a curated natural wine list that changes with the seasons.",
				"Menú de mercat, pa acabat de fer i vins naturals que canvien amb les estacions."
			),
			aboutTitle: buildML("Nuestra cocina", "Our kitchen", "La nostra cuina"),
			aboutDescription: buildML(
				"Trabajamos con proveedores locales para ofrecer platos frescos, con técnicas contemporáneas y una presentación cuidada.",
				"We partner with local producers to deliver fresh dishes with contemporary techniques and a refined presentation.",
				"Treballem amb productors locals per oferir plats frescos, tècniques contemporànies i una presentació cuidada."
			),
			menuTitle: buildML("Especialidades", "Specialties", "Especialitats"),
			menuSubtitle: buildML(
				"Platos pensados para compartir y disfrutar sin prisas.",
				"Plates designed to share and enjoy slowly.",
				"Plats pensats per compartir i gaudir sense presses."
			),
		},
		featuredBuilder: buildRestaurantFeatured,
		galleryBuilder: buildGallery,
	}),
	barber: ({ businessName, city }) => ({
		backgroundColor: "#0f172a",
		mainColor: "#eab308",
		fontFamily: "Space Grotesk, sans-serif",
		images: DEFAULT_IMAGES.barber,
		copy: {
			title: buildML(`${businessName}`, `${businessName}`, `${businessName}`),
			description: buildML(
				"Cortes precisos, rituales clásicos y productos de autor para cuidar tu estilo.",
				"Precision cuts, classic rituals and signature products to keep your style sharp.",
				"Talls precisos, rituals clàssics i productes d'autor per cuidar el teu estil."
			),
			heroTitle: buildHeroTitleML(
				businessName,
				"Barbería artesana para gente real",
				"Craft barbering for real people",
				"Barberia artesanal per a gent real"
			),
			heroSubtitle: buildML(
				"Técnica tradicional, acabados impecables y un ambiente pensado para desconectar.",
				"Traditional technique, flawless finishes and a space designed to disconnect.",
				"Tècnica tradicional, acabats impecables i un ambient pensat per desconnectar."
			),
			aboutTitle: buildML("Nuestro ritual", "Our ritual", "El nostre ritual"),
			aboutDescription: buildML(
				"Cuidamos cada detalle: toallas calientes, productos premium y asesoría personalizada.",
				"We care about every detail: hot towels, premium products and personal advice.",
				"Cuidem cada detall: tovalloles calentes, productes premium i assessorament personalitzat."
			),
			menuTitle: buildML("Servicios", "Services", "Serveis"),
			menuSubtitle: buildML(
				"Elige tu plan de grooming ideal.",
				"Pick your ideal grooming plan.",
				"Tria el teu pla de grooming ideal."
			),
		},
		featuredBuilder: (images) => [
			{
				id: "barber-feature-1",
				media: [{ url: images.product1 }],
				price: 25,
				title_ml: buildML(
					"Corte clásico + styling",
					"Classic cut & style",
					"Tall clàssic + styling"
				),
				description_ml: buildML(
					"Diagnóstico facial, corte a tijera o máquina y acabado con producto profesional.",
					"Face diagnosis, scissor or clipper cut and professional styling.",
					"Diagnòstic facial, tall a tisora o màquina i acabat professional."
				),
			},
			{
				id: "barber-feature-2",
				media: [{ url: images.product2 }],
				price: 19,
				title_ml: buildML(
					"Afeitado tradicional",
					"Traditional shave",
					"Afeitat tradicional"
				),
				description_ml: buildML(
					"Vaporizador de esencias, toalla caliente y navaja barbera con acabado hidratante.",
					"Scented steamer, hot towel and straight razor with hydrating finish.",
					"Vaporitzador d'essències, tovallola calenta i navalla amb acabat hidratant."
				),
			},
			{
				id: "barber-feature-3",
				media: [{ url: images.product3 }],
				price: 40,
				title_ml: buildML(
					"Plan full grooming",
					"Full grooming plan",
					"Pla grooming complet"
				),
				description_ml: buildML(
					"Corte + barba + ritual facial express con productos veganos.",
					"Haircut + beard + express facial ritual with vegan products.",
					"Tall + barba + ritual facial exprés amb productes vegans."
				),
			},
		],
		galleryBuilder: (images) => [
			{ id: "gallery-barber-1", image: images.services },
			{ id: "gallery-barber-2", image: images.reservations },
			{ id: "gallery-barber-3", image: images.about },
		],
	}),
	salon: ({ businessName, city }) => ({
		backgroundColor: "#fff5f8",
		mainColor: "#ec4899",
		fontFamily: "Poppins, sans-serif",
		images: DEFAULT_IMAGES.salon,
		copy: {
			title: buildML(
				`${businessName}: belleza consciente en ${city}`,
				`${businessName}: mindful beauty studio in ${city}`,
				`${businessName}: bellesa conscient a ${city}`
			),
			description: buildML(
				"Especialistas en color, skincare avanzado y rituales spa para cuerpo y mente.",
				"Specialists in colour, advanced skincare and spa rituals for body & mind.",
				"Especialistes en color, skincare avançat i rituals spa per a cos i ment."
			),
			heroTitle: buildHeroTitleML(
				businessName,
				"Hair & beauty studio moderno",
				"Modern hair & beauty studio",
				"Estudi modern de hair & beauty"
			),
			heroSubtitle: buildML(
				"Tratamientos veganos, colorimetría personalizada y técnicas de estética consciente.",
				"Vegan treatments, custom colour work and mindful aesthetic techniques.",
				"Tractaments vegans, colorimetria personalitzada i tècniques d'estètica conscient."
			),
			aboutTitle: buildML("Tu momento", "Your moment", "El teu moment"),
			aboutDescription: buildML(
				"Creamos experiencias sensoriales con diagnósticos personalizados y productos clean beauty.",
				"We create sensorial experiences with tailored diagnoses and clean beauty products.",
				"Creem experiències sensorials amb diagnòstics personalitzats i productes clean beauty."
			),
			menuTitle: buildML("Tratamientos", "Treatments", "Tractaments"),
			menuSubtitle: buildML(
				"Escoge entre hair spa, facial glow o rituales de bienestar.",
				"Choose between hair spa, facial glow or wellness rituals.",
				"Escull entre hair spa, facial glow o rituals de benestar."
			),
		},
		featuredBuilder: (images) => [
			{
				id: "salon-feature-1",
				media: [{ url: images.product1 }],
				price: 35,
				title_ml: buildML(
					"Color gloss vegano",
					"Vegan gloss colour",
					"Color gloss vegà"
				),
				description_ml: buildML(
					"Baño de color nutritivo con aceites orgánicos y acabado glass hair.",
					"Nourishing colour bath with organic oils and glass-hair finish.",
					"Bany de color nutritiu amb olis orgànics i acabat glass hair."
				),
			},
			{
				id: "salon-feature-2",
				media: [{ url: images.product2 }],
				price: 20,
				title_ml: buildML(
					"Facial glow detox",
					"Detox glow facial",
					"Facial glow detox"
				),
				description_ml: buildML(
					"Limpieza profunda, radiofrecuencia suave y máscara iluminadora.",
					"Deep cleanse, soft radiofrequency and brightening mask.",
					"Neteja profunda, radiofreqüència suau i màscara il·luminadora."
				),
			},
			{
				id: "salon-feature-3",
				media: [{ url: images.product3 }],
				price: "35 €",
				title_ml: buildML(
					"Ritual manicure spa",
					"Spa manicure ritual",
					"Ritual manicure spa"
				),
				description_ml: buildML(
					"Exfoliación, hidratación con mantecas y esmaltado vegano de larga duración.",
					"Exfoliation, butter hydration and long-lasting vegan polish.",
					"Exfoliació, hidratació amb mantegues i esmalt vegà llarga durada."
				),
			},
		],
		galleryBuilder: (images) => [
			{ id: "gallery-salon-1", image: images.services },
			{ id: "gallery-salon-2", image: images.reservations },
			{ id: "gallery-salon-3", image: images.about },
		],
	}),
	hairdresser: ({ businessName, city }) => ({
		backgroundColor: "#FFFBF8",
		mainColor: "#B5838D",
		fontFamily: "Cormorant Garamond, serif",
		images: DEFAULT_IMAGES.hairdresser,
		copy: {
			title: buildML(
				`${businessName}`,
				`${businessName}`,
				`${businessName}`
			),
			description: buildML(
				"Expertos en color, corte y tratamientos capilares personalizados para realzar tu belleza natural.",
				"Experts in colour, cut and personalised hair treatments to enhance your natural beauty.",
				"Experts en color, tall i tractaments capil·lars personalitzats per realçar la teva bellesa natural."
			),
			heroTitle: buildHeroTitleML(
				businessName,
				"Tu espacio de belleza capilar",
				"Your hair beauty space",
				"El teu espai de bellesa capil·lar"
			),
			heroSubtitle: buildML(
				"Colorimetría avanzada, cortes personalizados y tratamientos exclusivos en un espacio pensado para ti.",
				"Advanced colour work, personalised cuts and exclusive treatments in a space designed for you.",
				"Colorimetria avançada, talls personalitzats i tractaments exclusius en un espai pensat per a tu."
			),
			aboutTitle: buildML("Nuestro salón", "Our salon", "El nostre saló"),
			aboutDescription: buildML(
				"Creemos que cada persona merece sentirse especial. Combinamos técnica, creatividad y productos de alta gama para crear looks únicos que reflejen tu personalidad.",
				"We believe everyone deserves to feel special. We combine technique, creativity and premium products to create unique looks that reflect your personality.",
				"Creiem que cada persona mereix sentir-se especial. Combinem tècnica, creativitat i productes d'alta gamma per crear looks únics que reflecteixin la teva personalitat."
			),
			menuTitle: buildML("Nuestros servicios", "Our services", "Els nostres serveis"),
			menuSubtitle: buildML(
				"Tratamientos personalizados para el cuidado de tu cabello.",
				"Personalised treatments for your hair care.",
				"Tractaments personalitzats per a la cura del teu cabell."
			),
		},
		featuredBuilder: (images) => [
			{
				id: "hairdresser-feature-1",
				media: [{ url: images.product1 }],
				price: 65,
				title_ml: buildML(
					"Balayage personalizado",
					"Custom balayage",
					"Balayage personalitzat"
				),
				description_ml: buildML(
					"Técnica de mechas a mano alzada para un resultado natural y luminoso, adaptado a tu tono y estilo.",
					"Freehand highlights technique for a natural, luminous result adapted to your tone and style.",
					"Tècnica de metxes a mà alçada per un resultat natural i lluminós, adaptat al teu to i estil."
				),
			},
			{
				id: "hairdresser-feature-2",
				media: [{ url: images.product2 }],
				price: 35,
				title_ml: buildML(
					"Corte y peinado",
					"Cut & style",
					"Tall i pentinat"
				),
				description_ml: buildML(
					"Diagnóstico capilar, corte a medida y acabado profesional con secado y peinado.",
					"Hair diagnosis, tailored cut and professional finish with blow-dry and styling.",
					"Diagnòstic capil·lar, tall a mida i acabat professional amb assecat i pentinat."
				),
			},
			{
				id: "hairdresser-feature-3",
				media: [{ url: images.product3 }],
				price: 45,
				title_ml: buildML(
					"Tratamiento capilar reparador",
					"Restorative hair treatment",
					"Tractament capil·lar reparador"
				),
				description_ml: buildML(
					"Ritual de hidratación profunda con queratina vegetal y aceites esenciales para un cabello renovado.",
					"Deep hydration ritual with plant keratin and essential oils for renewed hair.",
					"Ritual d'hidratació profunda amb queratina vegetal i olis essencials per un cabell renovat."
				),
			},
		],
		galleryBuilder: (images) => [
			{ id: "gallery-hairdresser-1", image: images.services },
			{ id: "gallery-hairdresser-2", image: images.reservations },
			{ id: "gallery-hairdresser-3", image: images.about },
		],
	}),
	shop: ({ businessName, city }) => ({
		backgroundColor: "#ffffff",
		mainColor: "#111827",
		fontFamily: "Inter, sans-serif",
		images: DEFAULT_IMAGES.shop,
		copy: {
			title: buildML(
				`${businessName}`,
				`${businessName}`,
				`${businessName}`
			),
			description: buildML(
				`Tu tienda online en ${city} con productos únicos y de calidad.`,
				`Your online store in ${city} with unique and quality products.`,
				`La teva botiga online a ${city} amb productes únics i de qualitat.`
			),
			heroTitle: buildHeroTitleML(
				businessName,
				"Productos únicos para tu día a día",
				"Unique products for your everyday",
				"Productes únics per al teu dia a dia"
			),
			heroSubtitle: buildML(
				"Seleccionamos cuidadosamente cada artículo para ofrecerte calidad y diseño en cada compra.",
				"We carefully select each item to offer you quality and design in every purchase.",
				"Seleccionem acuradament cada article per oferir-te qualitat i disseny en cada compra."
			),
			aboutTitle: buildML("Nuestra tienda", "Our store", "La nostra botiga"),
			aboutDescription: buildML(
				"Trabajamos con marcas y artesanos que comparten nuestros valores de calidad, sostenibilidad y diseño.",
				"We work with brands and artisans who share our values of quality, sustainability and design.",
				"Treballlem amb marques i artesans que comparteixen els nostres valors de qualitat, sostenibilitat i disseny."
			),
			menuTitle: buildML("Productos destacados", "Featured products", "Productes destacats"),
			menuSubtitle: buildML(
				"Descubre nuestras selecciones más especiales.",
				"Discover our most special selections.",
				"Descobreix les nostres seleccions més especials."
			),
		},
		featuredBuilder: (images) => [
			{
				id: "shop-feature-1",
				media: [{ url: images.product1 }],
				price: 45.0,
				title_ml: buildML(
					"Bolso de cuero artesanal",
					"Handcrafted leather bag",
					"Bossa de cuir artesanal"
				),
				description_ml: buildML(
					"Bolso de cuero vegano con diseño minimalista, perfecto para el día a día. Hecho a mano en España.",
					"Vegan leather bag with minimalist design, perfect for everyday use. Handmade in Spain.",
					"Bossa de cuir vegà amb disseny minimalista, perfecte per al dia a dia. Fet a mà a Espanya."
				),
			},
			{
				id: "shop-feature-2",
				media: [{ url: images.product2 }],
				price: 28.5,
				title_ml: buildML(
					"Joyería minimalista",
					"Minimalist jewelry",
					"Joieria minimalista"
				),
				description_ml: buildML(
					"Piezas delicadas en plata de ley, diseñadas para acompañarte en cada momento especial.",
					"Delicate pieces in sterling silver, designed to accompany you in every special moment.",
					"Peces delicades en plata de llei, dissenyades per acompanyar-te en cada moment especial."
				),
			},
			{
				id: "shop-feature-3",
				media: [{ url: images.product3 }],
				price: 35.0,
				title_ml: buildML(
					"Accesorios de diseño",
					"Design accessories",
					"Accessoris de disseny"
				),
				description_ml: buildML(
					"Complementos únicos que combinan funcionalidad y estética para tu estilo personal.",
					"Unique accessories that combine functionality and aesthetics for your personal style.",
					"Complementos únics que combinen funcionalitat i estètica per al teu estil personal."
				),
			},
		],
		galleryBuilder: (images) => [
			{ id: "gallery-shop-1", image: images.services },
			{ id: "gallery-shop-2", image: images.reservations },
			{ id: "gallery-shop-3", image: images.about },
		],
	}),
	generic: ({ businessName, city }) =>
		presetBuilders.restaurant({ businessName, city }),
};

export const buildDefaultWebTemplate = (creator) => {
	const businessName =
		creator?.app?.name || creator?.businessName || "Tu negocio";
	const city = creator?.app?.city || "Barcelona";
	const phone = "";
	const email = "";
	const address = "";
	const category = getBusinessCategory(creator);
	const presetBuilder = presetBuilders[category] || presetBuilders.generic;
	const preset = presetBuilder({ businessName, city });
	const color = creator?.color || preset.mainColor;

	console.log(preset.featuredBuilder(preset.images));

	return {
		backgroundColor: preset.backgroundColor,
		mainColor: color,
		fontFamily: preset.fontFamily,
		logo: creator?.logo || buildPlaceholderLogo(color),
		previewImage: preset.images.preview,
		heroImage: preset.images.hero,
		menuImage: preset.images.services,
		reservaImage: preset.images.reservations,
		aboutUsImage: preset.images.about,
		aboutImage: preset.images.about,
		contactImage: preset.images.contact,
		contactMapUrl: "",
		contactPhone: phone,
		contactEmail: email,
		contactAddress: address,
		contactSchedule: buildSchedule(category),
		title_ml: preset.copy.title,
		description_ml: preset.copy.description,
		heroTitle_ml: preset.copy.heroTitle,
		heroSubtitle_ml: preset.copy.heroSubtitle,
		heroButton1_ml: buildML(
			category === "shop" ? "Ver productos" : category === "barber" ? "Reservar servicio" : category === "hairdresser" ? "Reservar cita" : "Reservar",
			category === "shop" ? "View products" : "Book now",
			category === "shop" ? "Veure productes" : "Reserva"
		),
		heroButton2_ml: buildML(
			category === "shop" ? "Comprar ahora" : category === "restaurant" ? "Ver menú" : category === "hairdresser" ? "Ver servicios" : "Descubrir servicios",
			category === "shop" ? "Shop now" : category === "restaurant" ? "See the menu" : "See services",
			category === "shop" ? "Comprar ara" : category === "restaurant" ? "Veure menú" : "Descobrir serveis"
		),
		aboutTitle_ml: preset.copy.aboutTitle,
		aboutDescription_ml: preset.copy.aboutDescription,
		menuTitle_ml: preset.copy.menuTitle,
		menuSubtitle_ml: preset.copy.menuSubtitle,
		reservationTitle_ml: buildML(
			category === "shop" 
				? "Catálogo completo" 
				: category === "restaurant" 
					? "Reserva tu experiencia" 
					: "Reserva tu cita",
			category === "shop"
				? "Full catalog"
				: category === "restaurant"
					? "Book your experience"
					: "Book your appointment",
			category === "shop"
				? "Catàleg complet"
				: category === "restaurant"
					? "Reserva la teva experiència"
					: "Reserva la teva cita"
		),
		reservationSubtitle_ml: buildML(
			category === "shop"
				? "Explora nuestra colección completa de productos cuidadosamente seleccionados."
				: category === "restaurant"
					? "Elige fecha, horario y déjanos el resto a nosotros."
					: "Selecciona tu servicio, profesional y horario preferido.",
			category === "shop"
				? "Explore our complete collection of carefully selected products."
				: category === "restaurant"
					? "Pick a date, time and let us handle the rest."
					: "Pick your service, professional and preferred time slot.",
			category === "shop"
				? "Explora la nostra col·lecció completa de productes acuradament seleccionats."
				: category === "restaurant"
					? "Tria data i deixa'ns la resta."
					: "Selecciona servei, professional i horari preferit."
		),
		contactTitle_ml: buildML(
			"Visítanos o escríbenos",
			"Visit or contact us",
			"Vine a veure'ns o escriu-nos"
		),
		contactSubtitle_ml: buildML(
			"Estamos en el corazón de la ciudad, listos para recibirte.",
			"We are in the heart of the city, ready to welcome you.",
			"Som al cor de la ciutat, a punt per rebre't."
		),
		contactInstagram: creator?.instagram || "https://instagram.com/applaby",
		featuredData: preset.featuredBuilder(preset.images),
		gallery: preset.galleryBuilder(preset.images),
		testimonials: [
			{
				id: "testimonial-default-1",
				author: "Caterina",
				role: "Cliente",
				rating: 5,
				comment_ml: buildML(
					"Una experiencia impecable: atención cercana y resultados espectaculares.",
					"Impeccable experience: caring team and outstanding results.",
					"Una experiència impecable: tracte proper i resultats espectaculars."
				),
			},
		],
	};
};

/**
 * Aplica los valores por defecto al webTemplate.
 *
 * @param {Object} template - El webTemplate guardado en base de datos
 * @param {Object} creator - El creator con información del negocio
 * @param {Object} options - Opciones adicionales
 * @param {boolean} options.webShowDefaults - Si es true, se aplican defaults. Si es false, se devuelve el template tal cual.
 * @returns {{ template: Object, isDemoContent: boolean }}
 */
export const withWebTemplateDefaults = (
	template,
	creator,
	{ webShowDefaults = true } = {}
) => {
	// Si webShowDefaults es false, devolver el template sin aplicar defaults
	if (!webShowDefaults) {
		return {
			template: template || {},
			isDemoContent: false,
		};
	}

	// Si webShowDefaults es true, aplicar defaults donde falten valores
	const defaults = buildDefaultWebTemplate(creator);
	const normalizedTemplate = normalizeTemplateMlFields(template);
	const hasUserCatalogConfig =
		normalizedTemplate?.showAllMenu === true ||
		(Array.isArray(normalizedTemplate?.featuredItems) &&
			normalizedTemplate.featuredItems.length > 0) ||
		hasMlContent(normalizedTemplate, "menuTitle") ||
		hasMlContent(normalizedTemplate, "menuSubtitle");

	// No sustituir la carta del usuario por productos demo si ya configuró menú
	if (hasUserCatalogConfig) {
		defaults.featuredData = [];
	}

	const merged = mergeDefaults(normalizedTemplate || {}, defaults);

	return {
		template: merged,
		isDemoContent: true,
	};
};
